// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"97caa30e","513":"1a600bbb","545":"8db5f7d4","787":"e829a29a"}[chunkId] + ".chunk.js";
};